/* ── Interview / Admin message templates ─────────────────────────────────────── */
const INTERVIEW_TEMPLATES = [
  {
    label: "👋 Greeting",
    text: "Hi! Welcome to your interview with Quantum Logics. We're glad to have you here. Let's get started!",
  },
  {
    label: "📋 Tasks intro",
    text: "So, there will be tasks based on learning. You will be assigned tasks that you have to complete. There is no fixed timing, but there will be a deadline by which you must finish them. Are you interested?",
  },
  {
    label: "✅ Wrap-up",
    text: "Thank you for your time. We will contact you via email if you are accepted. If you have any further questions, please feel free to ask.",
  },
  {
    label: "📎 Send details",
    text: "Please check your email for further instructions and details regarding the next steps.",
  },
  {
    label: "🕐 Schedule",
    text: "Could you let us know your availability for a technical discussion this week?",
  },
];

export default INTERVIEW_TEMPLATES;
